import React from "react";
import Cookies from "js-cookie";
import { groupBy } from "../utils";
import TabComponent from "../components/TabComponent";
import Components from "../services/Components";
import { getParams } from "../services/City";
import Loader from "../components/Loader";
import { addFormPost, editFormPost } from "../services/Form";
import { useHistory } from "react-router-dom";
import customSortFunction from "../utils/arrays";
import Sidebar from '../components/Sidebar'
import NewAddress from '../components/NewAddress'
function AddForm(props) {
  const history = useHistory();
  const [object, setObject] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [tabs, setTabs] = React.useState([]);
  const [tabsImage, setTabsImage] = React.useState({});
  const [style, setstyle] = React.useState("hide");
  const [active, setActive] = React.useState(null);

  const [submit, setSubmit] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [formId, setFormId] = React.useState(0);
  const [conti, setconti] = React.useState(0);
  const [response, setResponse] = React.useState(null);
  const [Address, setAddress] = React.useState(null);
  const [NewParam1, setNewParam1] = React.useState(null);
  const [NewParam2, setNewParam2] = React.useState(null);
  let username = Cookies.get('username');
  React.useEffect(() => {

    document.getElementById("btncontinue").disabled = true;
    let newArr1 = {
      ParamOrder: 0,
      id: 2913,
      name: "Parcel #",
      ParameterTypeId: 2,
      Phase: "Site Information",
      Stage: "form"
    }
    let newArr2 = {
      ParamOrder: 1,
      id: 3291,
      name: "Address",
      ParameterTypeId: 2,
      Phase: "Site Information",
      Stage: "form",
    }

    setNewParam1(newArr1)
    setNewParam2(newArr2)
    Cookies.remove('AddAddressString');
    Cookies.remove('searchString');
    getParams().then((res) => {
      console.log(res);
      // res.push(newArr1);
      //res.push(newArr2);
      let resp = res.sort((a, b) => (a.ParamOrder > b.ParamOrder ? 1 : -1));
      setData(resp.map((item) => ({ ...item, Value: "No" })));
      let obj = groupBy(resp, "Phase");
      setObject(obj);
    });
  }, []);


  function handleManual() {
    setstyle("");
    setconti(1);
  }
  function handlecontiune(e) {
    e.preventDefault();
    var isrequired = false;
    data.forEach(param => {
      if (param.ParameterId === 189) {
        if (param.Value === "No") {
          alert("Please Select Address");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 291) {
        if (param.Value === "No") {
          alert("Please Select Parcel #");
          isrequired = true;
          return;
        }
      }

    })
    if (isrequired === false) {
      setLoading(true);


      addFormPost(data, 0, tabsImage).then((res) => {
        setResponse(res);
        console.log(res);

        let resp = res.FormValues.sort((a, b) => a.ParamOrder - b.ParamOrder);
        setData(resp.map((item) => ({ ...item, Value: item.value.replace(/['"]+/g, "") })));
        let obj = groupBy(resp, "Phase");
        setObject(obj);
        Cookies.set('FormID', res.FormId);
        setFormId(res.FormId);
        let structures = {};
        res.StructureTypes.map((str, index) => {
          let newArr = [];
          str.Calculations.map((item) => {
            newArr.push({
              Phase: item.Phase,
              ParameterTypeId: item.ParameterTypeId,
              ParameterId: item.ParameterId,
              ParameterName: item.ParameterName,
              value: item.value.replace(/['"]+/g, ""),
              ischecked: false,
              structureType: str.StructureType,
              IsManual: item.IsManual,
              isComplete: item.isComplete,
              perhomevalue: item.perhomevalue,
              perprojectvalue: item.perprojectvalue,
              ParamOrder: item.ParamOrder,
            });
          });
          structures[str.StructureType] = groupBy(newArr, "Phase");


        });
        setTabs(structures);



        res.FormValues.map((item) => {

          if (item.ParameterId === 6) {
            if (item.value.replace(/['"]+/g, "") === "NR3" || item.value.replace(/['"]+/g, "") === "NR2" || item.value.replace(/['"]+/g, "") === "NR1" || item.value.replace(/['"]+/g, "") === "RSL") {
              setActive(Object.keys(structures)[0]);

            }
            else if (item.value.replace(/['"]+/g, "") === "LR1" || item.value.replace(/['"]+/g, "") === "LR2" || item.value.replace(/['"]+/g, "") === "LR3") {
              console.log("hes");
              setActive(Object.keys(structures)[1]);

            }
            else if (item.value.replace(/['"]+/g, "") === "NC1-30" || item.value.replace(/['"]+/g, "") === "NC1-40" || item.value.replace(/['"]+/g, "") === "NC1-55" || item.value.replace(/['"]+/g, "") === "NC2-30" || item.value.replace(/['"]+/g, "") === "NC2-40" || item.value.replace(/['"]+/g, "") === "NC2-55") {
              setActive(Object.keys(structures)[1]);

            }
            else if (item.value.replace(/['"]+/g, "") === "MR") {
              setActive(Object.keys(structures)[4]);

            }

            else {
              setActive(Object.keys(structures)[0]);
            }
          }
        });

        setSubmit(true);
        setLoading(false);
        document.getElementById("collapseADD").classList.toggle("collapse");
      });

    }
    else {
      return;
    }
    setstyle("");
    setconti(1);
    // const inputElement = document.getElementById("param2913");
    // if(inputElement.value.length <10)
    //     {
    //       document.getElementById('param2913').style.border="2px solid red";
    //     }
    //     else{
    //       const inputElement1 = document.getElementById("param291");
    //           const changeEvent = new Event("change");
    //           // Dispatch the event on the input element
    //           inputElement1.dispatchEvent(changeEvent);
    //           setconti(1);
    //           setstyle("");
    //     }

  }
  const onSubmit = (e) => {
    e.preventDefault();
    var isrequired = false;
    console.log(data);
    data.forEach(param => {
      if (param.ParameterId === 189) {
        if (param.Value === "No") {
          alert("Please Select Address");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 5) {
        if (param.Value === "No") {
          alert("Please Select Lot Size (ft)");
          isrequired = true;
          return;
        }
      }
      // else if (param.ParameterId === 10 ) { 
      //   if (param.Value === "No") {
      //     alert("Please Select Lot Depth (Ft)");
      //     isrequired=true;
      //     return;
      //   }
      // }
      // else if (param.ParameterId === 9) { 
      //   if (param.Value === "No") {
      //     alert("Please Select Lot Width (ft)");
      //     isrequired=true;
      //     return;
      //   }
      // }
      else if (param.ParameterId === 6) {
        if (param.Value === "No") {
          alert("Please Select Zoining");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 7) {
        if (param.Value === "No") {
          alert("Please Select MHA Suffix");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 29) {
        if (param.Value === "No") {
          alert("Please Select MHA Area");
          isrequired = true;
          return;
        }
      }
    })
    if (isrequired === false) {
      setLoading(true);

      if (formId > 0) {

        editFormPost(data, formId, tabsImage, tabs, '').then((res) => {
          setResponse(res);
          setFormId(res.FormId);
          // console.log("Mera response123", res);
          let resp = res.FormValues.sort((a, b) => a.ParamOrder - b.ParamOrder);
          setData(resp.map((item) => ({ ...item, Value: item.value.replace(/['"]+/g, "") })));
          let obj = groupBy(resp, "Phase");
          setObject(obj);
          // console.log("Mera data", data);
          let structures = {};
          res.StructureTypes.map((str, index) => {
            let newArr = [];
            str.Calculations.map((item) => {
              newArr.push({
                Phase: item.Phase,
                ParameterTypeId: item.ParameterTypeId,
                ParameterId: item.ParameterId,
                ParameterName: item.ParameterName,
                value: item.value.replace(/['"]+/g, ""),
                ischecked: item.ischecked,
                structureType: str.StructureType,
                IsManual: item.IsManual,
                isComplete: item.isComplete,
                perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
                ParamOrder: item.ParamOrder,
              });
            });
            structures[str.StructureType] = groupBy(newArr, "Phase");
            // structures[str.StructureType].StructureImages = [];
            // let imgs = tabsImage;
            // let imagesArrayFromResponse = res.StructureImages.map((item) => ({
            //   ...item,
            //   structure_type_id: item.structure_type_id.replace(/['"]+/g, ''),
            // }));
            // imgs[str.StructureType] = imagesArrayFromResponse.filter(
            //   (item) => item.structure_type_id === str.StructureType
            // );
            // imgs[str.StructureType] = imgs[str.StructureType].map(item => ({...item,image_url: item.image_url.replace(/['"]+/g, ''),image_type: item.image_type.replace(/['"]+/g, '')}))
            // setTabsImage(imgs);
            // console.log(imgs[str.StructureType]);

          });
          setTabs(structures);


          data.forEach(param => {
            if (param.ParameterId === 6) {
              if (param.Value === "NR3" || param.Value === "NR2" || param.Value === "NR1" || param.Value === "RSL") {

                setActive(Object.keys(structures)[0]);
                return;
              }
              else if (param.Value === "LR1" || param.Value === "LR2" || param.Value === "LR3") {

                setActive(Object.keys(structures)[1]);
                return;
              }
              else if (param.Value === "NC1-30" || param.Value === "NC1-40" || param.Value === "NC1-55" || param.Value === "NC2-30" || param.Value === "NC2-40" || param.Value === "NC2-55") {

                setActive(Object.keys(structures)[1]);
                return;
              }
              else if (param.Value === "MR") {

                setActive(Object.keys(structures)[4]);
                return;
              }
            }
          }
          );

          setSubmit(true);
          setLoading(false);
          document.getElementById("collapseADD").classList.toggle("collapse");
        });
      }
      else {
        addFormPost(data, 0, tabsImage).then((res) => {
          setResponse(res);
          console.log(res);

          let resp = res.FormValues.sort((a, b) => a.ParamOrder - b.ParamOrder);
          setData(resp.map((item) => ({ ...item, Value: item.value.replace(/['"]+/g, "") })));
          let obj = groupBy(resp, "Phase");
          setObject(obj);
          Cookies.set('FormID', res.FormId);
          setFormId(res.FormId);
          let structures = {};
          res.StructureTypes.map((str, index) => {
            let newArr = [];
            str.Calculations.map((item) => {
              newArr.push({
                Phase: item.Phase,
                ParameterTypeId: item.ParameterTypeId,
                ParameterId: item.ParameterId,
                ParameterName: item.ParameterName,
                value: item.value.replace(/['"]+/g, ""),
                ischecked: false,
                structureType: str.StructureType,
                IsManual: item.IsManual,
                isComplete: item.isComplete,
                perhomevalue: item.perhomevalue,
                perprojectvalue: item.perprojectvalue,
                ParamOrder: item.ParamOrder,
              });
            });
            structures[str.StructureType] = groupBy(newArr, "Phase");
            // structures[str.StructureType].StructureImages = [];
            // let imgs = tabsImage;
            // imgs[str.StructureType] = [
            //   // {
            //   //   structure_type_id: str.StructureType,
            //   //   image_type: "Google Map Location",
            //   //   image_name: "",
            //   //   image_url:
            //   //     "https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg",
            //   // },
            //   {
            //     structure_type_id: str.StructureType,
            //     image_type: "Lot Dimension",
            //     image_name: "",
            //     image_url:
            //       "https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg",
            //   },
            //   {
            //     structure_type_id: str.StructureType,
            //     image_type: "Water Main",
            //     image_name: "",
            //     image_url:
            //       "https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg",
            //   },
            //   {
            //     structure_type_id: str.StructureType,
            //     image_type: "Sewer Main",
            //     image_name: "",
            //     image_url:
            //       "https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg",
            //   },
            // ];

            // let imagesArrayFromResponse = res.StructureImages.map((item) => ({
            //   ...item,
            //   structure_type_id: item.structure_type_id.replace(/['"]+/g, ""),
            // }));
            // imgs[str.StructureType] = imagesArrayFromResponse.filter(
            //   (item) => item.structure_type_id === str.StructureType
            // );
            // imgs[str.StructureType] = imgs[str.StructureType].map((item) => ({
            //   ...item,
            //   image_url: item.image_url.replace(/['"]+/g, ""),
            //   image_type: item.image_type.replace(/['"]+/g, ""),
            // }));
            // setTabsImage(imgs);

          });
          setTabs(structures);



          res.FormValues.map((item) => {

            if (item.ParameterId === 6) {
              if (item.value.replace(/['"]+/g, "") === "NR3" || item.value.replace(/['"]+/g, "") === "NR2" || item.value.replace(/['"]+/g, "") === "NR1" || item.value.replace(/['"]+/g, "") === "RSL") {
                setActive(Object.keys(structures)[0]);

              }
              else if (item.value.replace(/['"]+/g, "") === "LR1" || item.value.replace(/['"]+/g, "") === "LR2" || item.value.replace(/['"]+/g, "") === "LR3") {
                console.log("hes");
                setActive(Object.keys(structures)[1]);

              }
              else if (item.value.replace(/['"]+/g, "") === "NC1-30" || item.value.replace(/['"]+/g, "") === "NC1-40" || item.value.replace(/['"]+/g, "") === "NC1-55" || item.value.replace(/['"]+/g, "") === "NC2-30" || item.value.replace(/['"]+/g, "") === "NC2-40" || item.value.replace(/['"]+/g, "") === "NC2-55") {
                setActive(Object.keys(structures)[1]);

              }
              else if (item.value.replace(/['"]+/g, "") === "MR") {
                setActive(Object.keys(structures)[4]);

              }

              else {
                setActive(Object.keys(structures)[0]);
              }
            }
          });

          setSubmit(true);
          setLoading(false);
          // document.getElementById("collapseADD").classList.toggle("collapse");
        });
      }
    }
    else {
      return;
    }
  };
  const onSubmitauto = (e) => {
    e.preventDefault();
    var isrequired = false;
    let Tab = e.target.id;
    let checkid = Tab.split('-')[0];

    if (isrequired === false) {

      editFormPost(data, formId, tabsImage, tabs, Tab).then((res) => {
        if (Tab.split('-')[1] == "All") {
          //history.push("/view/" + btoa(formId+"_"+username));
        }

      });

    }
    else {
      return;
    }
  };
  const onSubmit3 = (e) => {
    e.preventDefault();
    var isrequired = false;
    let Tab = e.target.id;
    let checkid = Tab.split('-')[0];
    data.forEach(param => {
      if (param.ParameterId === 189) {
        if (param.Value === "No") {
          alert("Please Select Address");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 5) {
        if (param.Value === "No") {
          alert("Please Select Lot Size (ft)");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 10) {
        if (param.Value === "No") {
          alert("Please Select Lot Depth (Ft)");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 9) {
        if (param.Value === "No") {
          alert("Please Select Lot Width (ft)");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 6) {
        if (param.Value === "No") {
          alert("Please Select Zoining");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 7) {
        if (param.Value === "No") {
          alert("Please Select MHA Suffix");
          isrequired = true;
          return;
        }
      }
      else if (param.ParameterId === 29) {
        if (param.Value === "No") {
          alert("Please Select MHA Area");
          isrequired = true;
          return;
        }
      }
    })
    if (isrequired === false) {

      if (Tab.split('-')[1] == "Site Potential") {
        tabs[active]["Site Potential"].find((item) => item.ParameterId == 85 && item.structureType == checkid).isComplete = 1;
      }
      if (Tab.split('-')[1] == "Building Cost Breakdown") {
        tabs[active]["Building Cost Breakdown"].find((item) => item.ParameterId == 198 && item.structureType == checkid).isComplete = 1;
      }
      if (Tab.split('-')[1] == "Sales Cost Breakdown") {
        if (Tab.split('-')[0] == "Single Family") {
          tabs[active]["Sales Cost Breakdown"].find((item) => item.ParameterId == 3249 && item.structureType == checkid).isComplete = 1;
        }
        else {
          tabs[active]["Sales Cost Breakdown"].find((item) => item.ParameterId == 3256 && item.structureType == checkid).isComplete = 1;
        }
      }
      if (Tab.split('-')[1] == "Land Analysis") {
        tabs[active]["Land Analysis"].find((item) => item.ParameterId == 243 && item.structureType == checkid).isComplete = 1;
      }
      if (Tab.split('-')[1] == "Financing") {
        tabs[active]["Financing"].find((item) => item.ParameterId == 56 && item.structureType == checkid).isComplete = 1;
      }
      if (Tab.split('-')[1] == "Proforma Breakdown") {
        if (Tab.split('-')[0] == "Townhome" || Tab.split('-')[0] == "Rowhouse" || Tab.split('-')[0] == "Cottage") {
          tabs[active]["Proforma Breakdown"].find((item) => item.ParameterId == 167 && item.structureType == checkid).isComplete = 1;
        }
        if (Tab.split('-')[0] == "Condo" || Tab.split('-')[0] == "Apartment") {
          tabs[active]["Proforma Breakdown"].find((item) => item.ParameterId == 143 && item.structureType == checkid).isComplete = 1;
        }
        if (Tab.split('-')[0] == "Single Family") {
          tabs[active]["Proforma Breakdown"].find((item) => item.ParameterId == 146 && item.structureType == checkid).isComplete = 1;
        }
      }
      const loaderElements = document.querySelectorAll('.loader123');
      loaderElements.forEach(loader => loader.style.display = loader.style.display === 'none' ? 'inline-block' : 'none');
      editFormPost(data, formId, tabsImage, tabs, Tab).then((res) => {
        if (Tab.split('-')[1] == "All") {
          history.push("/view/" + btoa(formId + "_" + username));
        }
        else {

          const loaderElements = document.querySelectorAll('.loader123');
          loaderElements.forEach(loader => loader.style.display = loader.style.display === 'none' ? 'inline-block' : 'none');
          // setSubmit(true);
          //setLoading(false);
        }
      });

    }
    else {
      return;
    }
  };


  return (

    <div id="wrapper" class="main_dashboard">
      <Sidebar main={"side-icon active"} home={"side-icon "} pass={"side-icon "} screen="" />
      <div id="content-wrapper" class="d-flex flex-column">
        {(conti == 0) ?
          <div class="mt-0">
            <div class="page-content-section">
              <div class="map img Landbrige_map">
                <div class="bg_content" >
                  <div class="text-map-content">
                    {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{ color: "white" }}></span>}

                    <h3 style={{ color: 'white' }}> <span>New Report AutoEntry<sup><span style={{ fontSize: "1.2rem" }}>TM</span></sup></span></h3>
                  </div>
                  <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                      <div class="row text-left">
                        <div class="newReportaddress col-md-12 mb-3">
                          <h6 class="alert alert-danger" role="alert" id="addressnot1" style={{ display: "none" }}></h6>
                          <NewAddress id={3291}
                            name={"Address"}
                            IsManual={true}
                            setData={setData}
                            data={data}
                            value={"0"}
                            structureType={""}
                            key={3291}
                            wholeEl={NewParam2}
                            ischecked={""}
                            object={null} />
                          {/* <input class="form-control newreport" placeholder="Address"></input> */}
                        </div>
                        <div class="col-md-12">
                          <p class="hr-lines" style={{ color: 'white' }}><span>or</span></p>
                        </div>
                        <div class="col-md-12  mb-5">
                          <NewAddress id={2913}
                            name={"Parcel #"}
                            IsManual={true}
                            setData={setData}
                            data={data}
                            value={"0"}
                            structureType={""}
                            key={2913}
                            wholeEl={NewParam1}
                            ischecked={""}
                            object={null} />
                          {/* <input class="form-control newreport" placeholder="Parcel #"></input> */}
                        </div>

                        <div class="col-md-6 mb-3 first-div">
                          <button class="btn btn-primary  btnmanual" type="button" onClick={handleManual}>
                            Manual Entry
                          </button>
                        </div>
                        <div class="col-md-6 mb-3 second-div">
                          <button class="btn btn-primary  btncontine" id="btncontinue" type="button" onClick={handlecontiune}>

                            {loading && (
                              <span
                                class="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div> : ""}

        <div id="content" class={style}>


          <div class="container-fluid">
            <div class="row">
              <div class="col-md-9 dashboard-city-box">
                <div class="table-content-propaty">
                  <div class="heading-propaty" >
                    <div class="row" style={{ width: "100%" }}>
                      <div class="col-md-12">
                        <h2 id="AddAddressString">{Cookies.get('AddAddressString') || ""}</h2>


                      </div>  </div></div>


                  <div class="card custom-accordian ">
                    <form id="accordion" class=" ">
                      <div

                        id="headingADD"
                        class="card-header"
                      >
                        <h5 class="mb-0">
                          <button class="btn btn-link w-100 d-flex justify-content-between align-items-center "
                            data-toggle="collapse" data-target="#collapseADD" aria-expanded="true" aria-controls="collapseADD"
                            onClick={(e) => e.preventDefault()}
                          >
                            <div class="left">
                              <span class="rotate-arrow">
                                <i class="fa fa-caret-right"></i>
                              </span>
                              <span> Property Information</span>
                            </div>
                            <div class="right">

                            </div>
                          </button>
                        </h5>
                        <h6 class="alert alert-danger" role="alert" id="addressnot" style={{ display: "none" }}></h6>

                      </div>
                      {!(object) ? <Loader /> :
                        <div
                          id="collapseADD"
                          aria-labelledby="headingADD"
                          data-parent="#accordion"

                        >

                          {Object.keys(object).map((name, index) => {

                            return (

                              <div class="card-body">
                                <span class="card-header">{name}
                                  {name == 'Site Information' ? (<a id={"siteinfo"} href="https://blue.kingcounty.com/Assessor/eRealProperty/Dashboard.aspx?ParcelNbr=0" target="_blank"><img class="iconimg" style={{ width: "3%" }} src="/assets/img/outside-page-LB.svg"></img></a>) : ""}

                                  {name == 'Geographical Analysis' ? (<a id={"geoana"} href="https://web.seattle.gov/dpd/ParcelData/Parcel.aspx?pin=0" target="_blank"><img class="iconimg" style={{ width: "3%" }} src="/assets/img/outside-page-LB.svg"></img></a>) : ""}
                                  {name == 'Utilities/Extras' ? (<a id={"utilityextra"} href="https://gisrevprxy.seattle.gov/wab_ext/DSOResearch_Ext" target="_blank"><img class="iconimg" style={{ width: "3%" }} src="/assets/img/outside-page-LB.svg"></img></a>) : ""}

                                </span>
                                <div class="input-box2 mt-2">
                                  {object &&
                                    object[name].map((item) =>
                                      <Components item={item} data={data} setData={setData} useVals={true} />
                                      // Components(item, data, setData, true)
                                    )}
                                </div>
                              </div>

                            );
                          })


                          }

                          {
                            <button
                              class="save"
                              style={{ float: "right", marginBottom: "5%", marginRight: "5%", minWidth: "22%" }}
                              onClick={onSubmit}
                            >
                              {loading && (
                                <span
                                  class="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}
                              Calculate
                            </button>
                          }
                        </div>
                      }
                    </form>
                  </div>
                  {submit && (
                    <form class="">
                      <ul class="nav mytab nav-pills justify-content-center mt-2" id="pills-tab" role="tablist">

                        {Object.keys(tabs).map((name, item) => {
                          let style = "nav-link ";
                          let issingleFamily = false;
                          let isNotsingleFamily = false;
                          let isNotsingleFamilyCond = false;
                          let isAptCond = false;
                          let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                          let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                          let viewBox = "0 1.117 17 14.767";
                          if (active === name) style += "active";

                          if (name == "Single Family") {

                            svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                          }
                          else if (name == "Townhome") {
                            viewBox = "0";
                            svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                            svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                          }
                          else if (name == "Rowhouse") {
                            svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                          }
                          else if (name == "Cottage") {
                            svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                          }
                          else if (name == "Condo") {
                            viewBox = "0";
                            svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                            svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                          }
                          else if (name == "Apartment") {

                            svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                            svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                            svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                            svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                            svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                            svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                            svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                            svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                          }
                          data.forEach(param => {
                            if (param.ParameterId === 6) {
                              if (param.Value === "NR3" || param.Value === "NR2" || param.Value === "NR1" || param.Value === "RSL") {

                                issingleFamily = true;
                                return;
                              }
                              if (param.Value === "LR1" || param.Value === "LR2" || param.Value === "LR3") {

                                isNotsingleFamily = true;
                                return;
                              }
                              if (param.Value === "NC1-30" || param.Value === "NC1-40" || param.Value === "NC1-55" || param.Value === "NC2-30" || param.Value === "NC2-40" || param.Value === "NC2-55") {

                                isNotsingleFamilyCond = true;
                                return;
                              }
                              if (param.Value === "MR") {

                                isAptCond = true;
                                return;
                              }
                            }
                          }
                          );
                          if (issingleFamily === true && name === "Single Family") {

                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(name)}>
                                <a class={style} id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                  role="tab" aria-controls="pills-home" aria-selected="true">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                    </g></svg>
                                </a>
                              </li>

                            );

                          }
                          if (isNotsingleFamily === true && name !== "Single Family") {
                            //setActive("Townhome");
                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(name)}>
                                <a class={style} id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                  role="tab" aria-controls="pills-profile" aria-selected="false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.427" height="52.53" viewBox={viewBox}>

                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                    </g>
                                  </svg>
                                </a>
                              </li>
                            );

                          }
                          if (isNotsingleFamilyCond === true && (name !== "Single Family" && name !== "Cottage")) {
                            //setActive("Townhome");
                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(name)}>
                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                  role="tab" aria-controls="pills-contact" aria-selected="false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                    </g></svg>
                                </a>
                              </li>

                            );

                          }
                          if (isAptCond === true && (name === "Apartment" || name === "Condo")) {
                            //setActive("Cottage");
                            return (
                              <li class="nav-item" role="presentation" onClick={() => setActive(name)}>
                                <a class={style} id="pills-contact-tab" data-toggle="pill" href="#pills-contact"
                                  role="tab" aria-controls="pills-contact" aria-selected="false">

                                  <svg xmlns="http://www.w3.org/2000/svg" width="52.498" height="52.387" viewBox={viewBox}>
                                    <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                      <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                      <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                      <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                      <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                      <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                      <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                    </g>
                                  </svg>
                                </a>
                              </li>
                            );

                          }
                          else {

                            return (
                              <button
                                type="button"
                                class={style}
                                style={{ display: "none" }}
                                onClick={() => setActive(name)}
                              >
                                {name}
                              </button>
                            );
                          }


                        }


                        )}
                      </ul>
                      <div class="tab-content">
                        {customSortFunction(Object.keys(tabs[active])).map(
                          (item, index) => {
                            let svgPath = ""; let svgPath1 = ""; let svgPath2 = ""; let svgPath3 = ""; let svgPath4 = "";
                            let svgPath5 = ""; let svgPath6 = ""; let svgPath7 = ""; let svgPath8 = "";
                            let viewBox = "0 1.117 17 14.767";

                            let style = "toptop  mt-2 text-center display";
                            if (item == "Site Potential") { style = "toptop  mt-2 text-center"; }
                            if (active == "Single Family") {

                              svgPath = "/assets/img/home.png"
                            }
                            else if (active == "Townhome") {
                              svgPath = "M43.329,41.65V8.5a1.806,1.806,0,0,0-1.2-1.755L22.273.092a1.791,1.791,0,0,0-1.662.277,1.928,1.928,0,0,0-.739,1.478v4.09L2.418.092A1.791,1.791,0,0,0,.756.369,1.928,1.928,0,0,0,.017,1.847V41.558A1.852,1.852,0,0,0,1.864,43.4H41.574A1.7,1.7,0,0,0,43.329,41.65ZM3.618,4.34,19.872,9.7V39.8h-6.28V29.644a1.847,1.847,0,0,0-3.694,0V39.8H3.618ZM39.82,39.8H33.54V29.644a1.847,1.847,0,1,0-3.694,0V39.8h-6.28V4.34L39.82,9.7Z"
                            }
                            else if (active == "Rowhouse") {
                              svgPath = "/assets/img/row.png"
                            }
                            else if (active == "Cottage") {
                              svgPath = "/assets/img/cot.png"
                            }
                            else if (active == "Condo") {
                              svgPath = "/assets/img/con.png"
                            }
                            else if (active == "Apartment") {
                              svgPath = "/assets/img/Apt.png"
                            }
                            if (active == "Single Family") {

                              svgPath = "m16.667 7.379-4.16-3.096V.723A.725.725 0 0 0 11.784 0a.726.726 0 0 0-.724.723v2.484L8.89 1.59a.706.706 0 0 0-.832 0L.281 7.38c-.325.217-.361.65-.144.976.217.326.65.362.976.145l.724-.535v8.312c0 .397.325.723.723.723h11.864c.398 0 .723-.326.76-.723V8.016l.65.484c.145.109.29.145.435.145.217 0 .434-.073.542-.29.217-.289.181-.76-.144-.976Zm-9.115 8.21v-3.617h1.88v3.617h-1.88Zm6.185 0h-2.858v-4.34a.726.726 0 0 0-.723-.723H6.864a.726.726 0 0 0-.723.723v4.34H3.247V8.174h10.49v7.415ZM3.507 6.728l4.985-3.69 2.79 2.076c.045.043.095.08.15.11l2.02 1.504H3.508Z"
                            }
                            else if (active == "Townhome") {
                              viewBox = "";
                              svgPath1 = "M13.357 26.493h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                              svgPath2 = "M13.357 17.441h1.435c1.104 0 2.208-.993 2.208-2.207a2.214 2.214 0 0 0-2.208-2.208h-1.435a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                              svgPath3 = "M37.09 26.493h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                              svgPath4 = "M37.09 17.441h1.436a2.214 2.214 0 0 0 2.208-2.207 2.214 2.214 0 0 0-2.208-2.208H37.09a2.214 2.214 0 0 0-2.208 2.208c0 1.214.994 2.207 2.208 2.207Z"

                              svgPath = "M51.773 49.785v-39.63c0-.993-.552-1.765-1.436-2.097L26.604.11c-.663-.22-1.435-.11-1.987.332-.552.441-.883 1.103-.883 1.766v4.89L2.87.11C2.208-.11 1.435 0 .883.442.331.883 0 1.545 0 2.208v47.467c0 1.214.994 2.208 2.208 2.208h47.467c1.214 0 2.208-.994 2.098-2.098ZM4.305 5.188l19.429 6.403v35.987h-7.507V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143H4.305V5.188Zm43.273 42.39H40.07V35.435a2.214 2.214 0 0 0-2.208-2.208 2.214 2.214 0 0 0-2.207 2.208v12.143h-7.507V5.188l19.429 6.403v35.987Z"
                            }
                            else if (active == "Rowhouse") {
                              svgPath = "M16.385 14.653h-.47V1.777a.672.672 0 0 0-.326-.543.621.621 0 0 0-.614 0L11.9 3.051v-1.31a.672.672 0 0 0-.325-.543.621.621 0 0 0-.615 0L7.704 3.146V1.74a.597.597 0 0 0-.325-.543c-.217-.108-.47-.108-.651.036l-5.354 3.87a.69.69 0 0 0-.253.507v9.042H.615a.634.634 0 0 0-.615.615c0 .326.29.615.615.615H16.385c.326 0 .615-.29.615-.615a.634.634 0 0 0-.615-.615Zm-5.75-11.827v11.827h-2.93V4.563l2.93-1.737ZM2.35 5.9l4.123-2.966v11.72H5.028v-2.641a.634.634 0 0 0-.615-.615.634.634 0 0 0-.615.615v2.64H2.35V5.9Zm9.549 8.753V4.463l2.749-1.637v11.827H11.9Z"
                            }
                            else if (active == "Cottage") {
                              svgPath = "M8.879.126c-.253-.144-.541-.144-.758 0C2.887 3.375 0 7.706 0 12.29v3.97c0 .397.325.722.722.722h15.52a.779.779 0 0 0 .758-.686V12.29C17 7.67 14.113 3.375 8.879.126ZM6.786 15.574v-4.511h3.356v4.511H6.786Zm8.77 0h-3.97v-5.197a.724.724 0 0 0-.722-.722H6.1a.724.724 0 0 0-.722.722v5.197h-3.97V12.29c0-4.007 2.526-7.796 7.074-10.72 4.584 2.96 7.074 6.75 7.074 10.72v3.284Z"
                            }
                            else if (active == "Condo") {
                              viewBox = "";
                              svgPath1 = "M32.435 43.024a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.23 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                              svgPath2 = "M19.952 43.024c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.23 2.236 2.236 0 0 0-2.229 2.23v2.787a2.236 2.236 0 0 0 2.23 2.229Z"

                              svgPath3 = "M32.435 29.537a2.236 2.236 0 0 0 2.23-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.23 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                              svgPath4 = "M19.952 29.537c1.226 0 2.117-1.003 2.229-2.23v-2.786a2.236 2.236 0 0 0-2.23-2.229 2.236 2.236 0 0 0-2.229 2.23v2.786a2.236 2.236 0 0 0 2.23 2.229Z"

                              svgPath = "M50.269 47.928h-2.787V17.504l1.784.775c.334.112.557.223.891.223.892 0 1.672-.557 2.007-1.337.446-1.115 0-2.452-1.115-2.898L40.683 9.774V2.229A2.236 2.236 0 0 0 38.454 0a2.236 2.236 0 0 0-2.23 2.23V7.84l-14.49-6.28c-.668-.224-1.448-.224-2.117.222L1.003 14.49C0 15.159-.223 16.496.446 17.5c.669 1.002 2.006 1.225 3.01.557l1.56-1.067v30.938H2.229A2.236 2.236 0 0 0 0 50.158a2.236 2.236 0 0 0 2.23 2.229h47.927c1.226 0 2.341-1.004 2.341-2.23a2.236 2.236 0 0 0-2.23-2.229ZM9.215 14.12l11.851-8.101 21.958 9.547v32.362H9.474v-32.77c0-.374-.094-.728-.259-1.038Z"
                            }
                            else if (active == "Apartment") {

                              svgPath1 = "M2.894 12.551a.726.726 0 0 0-.724.723v.217c0 .398.326.724.724.724.361 0 .687-.29.723-.724v-.217a.726.726 0 0 0-.723-.723Z"

                              svgPath2 = "M2.894 9.006a.726.726 0 0 0-.724.724v.217c0 .398.326.723.724.723.361 0 .687-.325.723-.723V9.73a.726.726 0 0 0-.723-.724Z"

                              svgPath3 = "M14.106 14.215c.398 0 .724-.29.724-.724v-.217a.726.726 0 0 0-.724-.723.726.726 0 0 0-.723.723v.217c0 .398.326.724.723.724Z"

                              svgPath4 = "M14.106 10.67a.726.726 0 0 0 .724-.723V9.73a.726.726 0 0 0-.724-.724.726.726 0 0 0-.723.724v.217c0 .398.326.723.723.723Z"

                              svgPath5 = "M9.549 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                              svgPath6 = "M7.451 7.777c.398 0 .723-.29.723-.724v-.108a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v.108c0 .398.325.724.723.724Z"
                              svgPath7 = "M9.549 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"
                              svgPath8 = "M7.451 4.521a.726.726 0 0 0 .723-.723v-.109a.726.726 0 0 0-.723-.723.726.726 0 0 0-.723.723v.109c0 .398.325.723.723.723Z"

                              svgPath = "M16.277 5.787h-3.581V.723A.726.726 0 0 0 11.972 0H5.064a.726.726 0 0 0-.724.723v5.064H.723A.726.726 0 0 0 0 6.511v9.766c0 .397.326.723.723.723h15.553a.726.726 0 0 0 .724-.723V6.51a.725.725 0 0 0-.723-.724Zm-5.064-4.376V15.589h-1.99v-4.412a.726.726 0 0 0-.723-.724.726.726 0 0 0-.723.724v4.412h-1.99V6.511a.717.717 0 0 0-.036-.225V1.41h5.462ZM1.41 7.234h2.93v8.355H1.41V7.234Zm14.178 8.355h-2.893V7.234h2.893v8.355Z"
                            }
                            return (
                              <>

                                <div class={style}>
                                  <h2 class="d-flex align-items-center justify-content-center" style={{ color: "#a0b3c6" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="52.338" height="52.498" viewBox={viewBox} style={{ marginRight: "3%" }}>
                                      <g xmlns="http://www.w3.org/2000/svg" data-name="Group 21">
                                        <path d={svgPath1} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath2} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath3} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath4} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />
                                        <path d={svgPath5} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 552" />
                                        <path d={svgPath6} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 551" />
                                        <path d={svgPath7} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 550" />
                                        <path d={svgPath8} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 549" />

                                        <path d={svgPath} fill="#a0b3c6" fill-rule="evenodd" data-name="Path 548" />
                                      </g></svg>
                                    {active} Evaluation
                                  </h2>
                                  <p style={{ marginLeft: "8%", marginTop: "-2%", color: "#a0b3c6" }}>
                                    Select a structure type to start evaluation.
                                  </p>
                                </div>
                                <div class="card custom-accordian mt-2" style={{ border: "0px !important" }}>
                                  <TabComponent
                                    key={index.toString()}
                                    name={item}
                                    object={tabs[active]}
                                    index={index}
                                    useVals={true}
                                    setTabsImage={setTabsImage}

                                    active={active}
                                    setObject2={(data) => {
                                      // console.log(data);
                                      let t = tabs;
                                      tabs[data.structureType][data.Phase] = tabs[
                                        data.structureType
                                      ][data.Phase].map((item) =>
                                        item.ParameterId === data.ParameterId
                                          ? data
                                          : item
                                      );
                                      setTabs(t);
                                    }}
                                  />
                                  <div class="mb-4"></div>
                                  {/* {item !== "StructureImages" ? (
                         <div
                         id={`collapse${index}`}
                         class="accordion-collapse collapse show"
                         aria-labelledby="headingOne"
                         data-bs-parent="#accordionExample"
                       >
                       <button
                       class="save"
                       onClick={onSubmit3}
                       id={active+"-"+item}
                       style={{float:"right",marginBottom:"1%",marginRight:"2%", minWidth:"22%"}}
                       disabled={loading}
                     >
                       {(
                         <span
                         name="loader123"
                         style={{display:"none"}}
                           class="loader123 spinner-border spinner-border-sm mr-2"
                           role="status"
                           aria-hidden="true"
                         ></span>
                       )}
                         Save and Continue
                     </button>
                     </div>):(
                        ""
                      )} */}

                                </div>
                              </>
                            );
                          }
                        )}

                        <div class="card custom-accordian mt-2" >
                          <div class="row card-body" >
                            {object && object["Property Images"].map((item) => (
                              <div class=" col-md-4   ">
                                <h6><b>{item.ParameterName}</b><br /></h6>
                                <img src={item.value.replace(/['"]+/g, "")} alt="LB-Icon-White.svg" style={{ minWidth: "100%" }}></img>
                              </div>
                            ))}
                            <div class="col-md-12 mt-2">
                              <button
                                class="save"
                                // onClick={(e) => {
                                //   e.preventDefault();
                                //   setSubmit(false);
                                //   document
                                //     .getElementById("collapseADD")
                                //     .classList.toggle("collapse");
                                // }}
                                style={{ float: "right", minWidth: "22%", marginBottom: "5%", marginRight: "5%" }}
                                onClick={onSubmit3}
                                disabled={loading}
                                id={active + "-All"}
                              >
                                {(
                                  <span
                                    name="loader123"
                                    style={{ display: "none" }}
                                    class="loader123 spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Run Report
                              </button>
                              <button
                                class="save"
                                style={{ float: "right", minWidth: "23.5%", marginRight: "-1.5%", display: "none" }}
                                onClick={onSubmitauto}
                                disabled={loading}
                                id={active + "-All-Auto"}
                              >
                                {(
                                  <span
                                    name="loader123"
                                    style={{ display: "none" }}
                                    class="loader123 spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                Run Report
                              </button>
                            </div>
                          </div>
                        </div>


                      </div>
                    </form>
                  )}

                </div>

              </div>
              <div class="col-md-3 city-dashboard img Landbrige_map" >
                <div class="bg_content">
                  <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                  <h2>land analysis made simple</h2>
                </div>
              </div>
            </div></div>
        </div></div> </div>
  );
}

export default AddForm;
